import { apiClient } from './client.js'

const DEFAULT_PAGE = 1
const DEFAULT_LIMIT = 20

const buildQuery = (params = {}) => {
  const query = new URLSearchParams()

  const start = params.start_date || params.startDate
  const end = params.end_date || params.endDate
  if (start) query.append('start_date', start)
  if (end) query.append('end_date', end)
  if (params.category_id || params.reportCategoryId) query.append('category_id', params.category_id || params.reportCategoryId)
  if (params.product_id || params.reportProductId) query.append('product_id', params.product_id || params.reportProductId)
  if (params.source) query.append('source', params.source)
  if (params.sales_type_id) query.append('sales_type_id', params.sales_type_id)
  if (params.sales_type) query.append('sales_type', params.sales_type)
  query.append('page', String(params.page || DEFAULT_PAGE))
  query.append('limit', String(params.limit || DEFAULT_LIMIT))

  return query.toString()
}

const buildDashboardQuery = (params = {}) => {
  const query = new URLSearchParams()

  if (params.start_date && params.end_date) {
    query.append('start_date', params.start_date)
    query.append('end_date', params.end_date)
  }
  if (params.pending_limit) query.append('pending_limit', String(params.pending_limit))
  if (params.chart_granularity) query.append('chart_granularity', String(params.chart_granularity))
  if (params.chart_start_month) query.append('chart_start_month', String(params.chart_start_month))
  if (params.chart_end_month) query.append('chart_end_month', String(params.chart_end_month))
  if (params.chart_start_year) query.append('chart_start_year', String(params.chart_start_year))
  if (params.chart_end_year) query.append('chart_end_year', String(params.chart_end_year))

  return query.toString()
}

export const reportService = {
  getActivePeriod: () => {
    return apiClient.get('/reports/active-period')
  },
  getDashboard: (params = {}) => {
    const query = buildDashboardQuery(params)
    return apiClient.get(`/reports/dashboard${query ? `?${query}` : ''}`)
  },

  getShiftHistory: (params = {}) => {
    return apiClient.get(`/reports/shifts?${buildQuery(params)}`)
  },

  getTransactionHistory: (params = {}) => {
    return apiClient.get(`/reports/transaction-history?${buildQuery(params)}`)
  },

  getProfitSalesReport: (params = {}) => {
    return apiClient.get(`/reports/profit-sales?${buildQuery(params)}`)
  },

  getSalesReport: (params = {}) => {
    return apiClient.get(`/reports/sales?${buildQuery(params)}`)
  },

  getProductRecap: (params = {}) => {
    return apiClient.get(`/reports/recap/products?${buildQuery(params)}`)
  },

  getUnitRecap: (params = {}) => {
    return apiClient.get(`/reports/recap/units?${buildQuery(params)}`)
  },

  getCategoryRecap: (params = {}) => {
    return apiClient.get(`/reports/recap/categories?${buildQuery(params)}`)
  },

  getPaymentRecap: (params = {}) => {
    return apiClient.get(`/reports/recap/payments?${buildQuery(params)}`)
  },

  getSalesTypeRecap: (params = {}) => {
    return apiClient.get(`/reports/recap/sales-types?${buildQuery(params)}`)
  },

  getVoidTransactions: (params = {}) => {
    return apiClient.get(`/reports/void-transactions?${buildQuery(params)}`)
  },

  getProfitLoss: (params = {}) => {
    return apiClient.get(`/reports/profit-loss?${buildQuery(params)}`)
  }
}
